import React from 'react'
import { HBox, Wrapper } from 'src/ui/layout'
import { Hero } from 'src/ui/organisms'
import { Body, Header } from 'src/ui/typography'
import { useTheme } from 'src/ui/theme'
import { Image } from 'src/ui/atoms'

type Props = {
  images: TImages
}

export const Benefits = ({ images }: Props) => {
  const theme = useTheme()
  return (
    <>
      <Wrapper>
        <Header as="h4" size="h4">
          Создаем среду для роста и комфорта
        </Header>
      </Wrapper>
      <HBox />
      <Hero
        title="Развиваем профессионализм"
        background={images['benefits-mob']}
      >
        <HBox />
        <Body color={theme.colors.black.secondary}>
          Грейды, карьерный трек, обучение и технологизации для роста
          сотрудников
        </Body>
      </Hero>
      <HBox />
      <Hero
        title="Воплощаем идеи в реальность"
        background={images['benefits-mob2']}
      >
        <HBox />
        <Body color={theme.colors.black.secondary}>
          KODE даёт возможность запускать стартапы, открывать подразделения и
          строить эффективные процессы
        </Body>
      </Hero>
      <HBox />
      <Hero title="Заботимся о здоровье" background={images['benefits-mob3']}>
        <HBox />
        <Body color={theme.colors.black.secondary}>
          ДМС, компенсация тренировок, походы и путешествия
        </Body>
      </Hero>
      <HBox />
      <HBox height={49} />
      <Wrapper>
        <Header as="h4" size="h4">
          Рост зарплат на 28,4%
        </Header>
        <HBox />
        <Header as="h5" size="h5">
          1 млн. рублей в год проактивным сотрудникам из Фонда KODE
        </Header>
        <HBox />
        <Body color={theme.colors.black.secondary}>
          *на фото Финансовый директор KODE
        </Body>

        <HBox height={32} />

        <Image fluid={images['benefits-mob4']} />
      </Wrapper>
    </>
  )
}
